import React, { useState, useEffect, Fragment, useCallback } from 'react';
import {
    Card, CardBody, Button, TabContent, TabPane, NavItem, CardHeader, Nav, Row,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Vouchers_Icons, gAPI_BmbUploads } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import UploadImagesButton from './components/UploadIconsButton';
import Gallery from "react-photo-gallery";
import SelectedIcon from './components/SelectedIcon'
import UserUploadSelectedImage from './components/UserUploadSelectedIcons'
import Pagination from "../../../../../containers/pages/Pagination";
import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';

function IconGallery({ propertyId, selectedImage, togglegallery, hideUserUploads, searchText ,direct }) {

    if (hideUserUploads === undefined) {
        hideUserUploads = false;
    }
    if (searchText === undefined) {
        searchText = '';
    }

    const [activeTab, setActiveTab] = useState('embed');
    const [loading, setLoading] = useState(true);
    const [bmbloading, setbmbLoading] = useState(true);
    const [photos, setphotos] = useState([]);
    const [bmbphotos, setbmbphotos] = useState([]);
    const [chosenImage, setchosenImage] = useState('');
    const [bmbsearch, setBmbSearch] = useState(searchText);
    const [myUploadSearch, setmyUploadSearch] = useState('');
    const [bmbpageSizes, setbmbpageSizes] = useState([10, 15, 20, 25]);
    const [bmbcurrentPage, setbmbcurrentPage] = useState(1);
    const [bmbSelectedPageSize, setbmbSelectedPageSize] = useState(10);
    const [bmbTotalItems, setbmbTotalItems] = useState(0);
    const [bmbTotalPages, setbmbTotalPages] = useState(1);
    const [bmbUploadButton, setBmbUploadButton] = useState(false);
    const [userpageSizes, setuserpageSizes] = useState([10, 15, 20, 25]);
    const [usercurrentPage, setusercurrentPage] = useState(1);
    const [userSelectedPageSize, setuserSelectedPageSize] = useState(10);
    const [userTotalItems, setuserTotalItems] = useState(0);
    const [userTotalPages, setuserTotalPages] = useState(1);

    const toggleAppMenu = tab => {
        setActiveTab(tab)
    };
    useEffect(() => {
      if(activeTab === "embed")
        LoadData();
    }, [propertyId, activeTab, usercurrentPage, userSelectedPageSize]);

    useEffect(() => {
        if(activeTab === "standard"){
        ShowUploadButton();
        LoadBmbData();
        }
    }, [propertyId, activeTab,bmbcurrentPage, bmbSelectedPageSize]);

    const ShowUploadButton = () => {
        const userId = getUserID();
        if (userId == "0b264b20-dc1a-40e9-87d2-8877b5a0e089" || userId == "6fc9447c-ddc3-4b0c-9af5-464471e5cd55" || userId == "a98e69d8-9c90-48cd-ae61-de4628be2b15") {
            setBmbUploadButton(true);
        }
    };
    const [selectAll, setSelectAll] = useState(false);
    const imageRenderer = useCallback(
        ({ index, left, top, key, photo }) => (
            <SelectedIcon
                selected={selectAll ? true : false}
                key={key}
                margin={"2px"}
                index={index}
                photo={photo}
                left={left}
                top={top}
                ParentImage={ParentImage}
                chosenImage={chosenImage}
                ParentDeleteImage={ParentDeleteImage}
                ParentEditImage={ParentEditImage}
            />
        )
    );
    const onSearchKey = e => {
        if (e.key === "Enter") {
            setbmbcurrentPage(1)
            setBmbSearch(e.target.value.toLowerCase())
        }
    };
    const onSearchKeyUserUploads = e => {
        if (e.key === "Enter") {
            setusercurrentPage(1)
            setmyUploadSearch(e.target.value.toLowerCase())
        }
    };

    const changeBmbPageSize = size => {
        setbmbSelectedPageSize(size)
        setbmbcurrentPage(1)
    };

    const onChangeBmbPage = page => {
        setbmbcurrentPage(page)
    };

    const changeUserPageSize = size => {
        setuserSelectedPageSize(size)
        setusercurrentPage(1)
    };

    const onChangeUserPage = page => {
        setusercurrentPage(page)
    };

    const UserImageRenderer = useCallback(
        ({ index, left, top, key, photo }) => (
            <UserUploadSelectedImage
                selected={selectAll ? true : false}
                key={key}
                margin={"2px"}
                index={index}
                photo={photo}
                left={left}
                top={top}
                ParentUserUploadImage={ParentUserUploadImage}
                chosenImage={chosenImage}
                ParentUserDeleteImage={ParentUserDeleteImage}
                ParentUserEditImage={ParentUserEditImage}
            />
        )
    );

    const ParentImage = (id) => {
        setchosenImage(id)
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        bmbphotos[objIndex].selected = true;
        setbmbphotos(bmbphotos)
    }

    const ParentDeleteImage = (id) => {
        const values = [...bmbphotos];
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        values.splice(objIndex, 1);
        setbmbphotos(values)
    }

    const ParentEditImage = (id, tags) => {
        let objIndex = bmbphotos.findIndex((obj => obj.id == id));
        bmbphotos[objIndex].tags = true;
        setbmbphotos(bmbphotos)
    }

    const ParentUserDeleteImage = (id) => {
        const values = [...photos];
        let objIndex = photos.findIndex((obj => obj.id == id));
        values.splice(objIndex, 1);
        setphotos(values)
    }

    const ParentUserEditImage = (id, tags) => {
        let objIndex = photos.findIndex((obj => obj.id == id));
        photos[objIndex].tags = true;
        setphotos(photos)
    }

    const ParentUserUploadImage = (id) => {
        setchosenImage(id)
        let objIndex = photos.findIndex((obj => obj.id == id));
        photos[objIndex].selected = true;
        setphotos(photos)
    }

    const AddImage = () => {
        let objIndex = bmbphotos.findIndex((obj => obj.id == chosenImage));
        selectedImage(bmbphotos[objIndex]);
        togglegallery()
    }

    const AddUserImage = () => {
        let objIndex = photos.findIndex((obj => obj.id == chosenImage));
        selectedImage(photos[objIndex]);
        togglegallery()
    }

    const LoadData = () => {
        if (hideUserUploads != true) {
            let searchkeyword = bmbsearch;
            if (bmbsearch === 'avatar') {
                searchkeyword = '';
            }
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_Vouchers_Icons}?group_id=${getGroupID()}&property_id=${propertyId}&pageNumber=${usercurrentPage}&pageSize=${userSelectedPageSize}&propertyId=${propertyId}`,
            })
                .then(res => {
                if(res.data.icons !== undefined){
                    console.log(res.data);
                    setphotos(res.data.icons);
                    setuserTotalItems(res.data.totalItems)
                    setuserTotalPages(res.data.totalPages)
                    setLoading(false);
                    }
                })
                .catch(err => console.log('err', err));
        }
    }

    const LoadBmbData = () => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Vouchers_Icons}/all?pageNumber=${bmbcurrentPage}&pageSize=${bmbSelectedPageSize}`,
        })
            .then(res => {
                if(res.data.icons !== undefined){
                setbmbphotos(res.data.icons);
                setbmbTotalItems(res.data.totalItems)
                setbmbTotalPages(res.data.totalPages)
                setbmbLoading(false);
                }
            })
            .catch(err => console.log('err', err));
    }

    const startBmbIndex = (bmbcurrentPage - 1) * bmbSelectedPageSize;
    const endBmbIndex = bmbcurrentPage * bmbSelectedPageSize;
    const startUserIndex = (usercurrentPage - 1) * userSelectedPageSize;
    const endUserIndex = usercurrentPage * userSelectedPageSize;
    return (
        <Fragment>
            <CardHeader className="pl-0 pr-0">
                <Nav tabs className="card-header-tabs ml-0 mr-0">
                <NavItem className={`${(direct !== undefined && direct === true)  ? "text-center":"text-center"}`}>
                        <NavLink
                            className={classnames({
                                active: activeTab === "standard",
                                "nav-link": true
                            })}
                            onClick={() => {
                                toggleAppMenu("standard");
                            }}
                            to="#"
                        >
                            Gallery from <strong>aiva</strong>
                        </NavLink>
                    </NavItem>
                    {hideUserUploads != true ? (
                       <NavItem className={`${(direct !== undefined && direct === true)  ? "text-center":"text-center"}`}>
                            <NavLink
                                className={classnames({
                                    active: activeTab === "embed",
                                    "nav-link": true
                                })}
                                onClick={() => {
                                    toggleAppMenu("embed");
                                }}
                                to="#"
                            >
                                My Uploads
                            </NavLink>
                        </NavItem>
                    ) : null}

                </Nav>
            </CardHeader>

            <TabContent
                activeTab={activeTab}
                className=""
            >
                <TabPane tabId="standard" className="chat-app-tab-pane">
                    <Card className="mb-4">
                        <CardBody>
                            <Row>
                                <Colxx xxs="3">
                                    <UploadImagesButton propertyId={propertyId} bmb={false} parentLoadData={LoadBmbData} />
                                </Colxx>
                                <Colxx xxs="6"></Colxx>
                                <Colxx xxs="3">
                                    {/* <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top" style={{ width: '100%' }}>
                                        <input
                                            type="text"
                                            name="keyword"
                                            id="search"
                                            placeholder="Search "
                                            onKeyPress={e => onSearchKey(e)}
                                            style={{ width: '60%' }}
                                        />
                                    </div> */}

                                    <div className="float-md-right">
                                        <span className="text-muted text-small mr-1">{`${startBmbIndex}-${endBmbIndex} of ${bmbTotalItems} `}</span>
                                        <UncontrolledDropdown className="d-inline-block">
                                            <DropdownToggle caret color="outline-dark" size="xs">
                                                {bmbSelectedPageSize}
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                {bmbpageSizes.map((size, index) => {
                                                    return (
                                                        <DropdownItem
                                                            key={index}
                                                            onClick={() => changeBmbPageSize(size)}
                                                        >
                                                            {size}
                                                        </DropdownItem>
                                                    );
                                                })}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </Colxx>
                            </Row>
                            
                            {!bmbloading && (
                                <Row className='my-3'>
                                    <Colxx xxs="12">
                                        <div className='row'>
                                            {bmbphotos && bmbphotos.map((img, index) => (
                                                <div className='col-md-1'>
                                                    <SelectedIcon
                                                        selected={selectAll ? true : false}
                                                        key={index}
                                                        margin={'2px'}
                                                        index={index}
                                                        photo={img}
                                                        left={'1px'}
                                                        top={'1px'}
                                                        ParentImage={ParentImage}
                                                        chosenImage={chosenImage}
                                                        ParentDeleteImage={ParentDeleteImage}
                                                        ParentEditImage={ParentEditImage}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </Colxx>
                                </Row>
                            )}
                            <Row>
                                <Pagination
                                    currentPage={bmbcurrentPage}
                                    totalPage={bmbTotalPages}
                                    onChangePage={i => onChangeBmbPage(i)}
                                />
                            </Row>
                            <Row className="mt-3">
                                <Colxx xxs="6">
                                    {/* {bmbUploadButton && (
                                        <UploadImagesButton propertyId={propertyId} bmb={true} parentBmbData={LoadBmbData} />
                                    )} */}
                                </Colxx>
                                <Colxx xxs="6">
                                    {togglegallery && (
                                        <div className="float-right">
                                            <Button
                                                color="secondary"
                                                className="add-button"
                                                size="xs"
                                                onClick={AddImage}
                                            >
                                                Add to my Chatbot
                                            </Button>
                                        </div>
                                    )}
                                </Colxx>
                            </Row>
                        </CardBody>
                    </Card>
                </TabPane>
                {hideUserUploads != true ? (<TabPane tabId="embed" className="chat-app-tab-pane">
                    <Card className="mb-4">
                        <CardBody>
                            <Row>
                                <Colxx xxs="3">
                                    <UploadImagesButton propertyId={propertyId} bmb={true} parentLoadData={LoadData} />
                                </Colxx>
                                <Colxx xxs="6"></Colxx>
                                {/* <Colxx xxs="6">
                                    <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top" style={{ width: '100%' }}>
                                        <input
                                            type="text"
                                            name="keyword"
                                            id="search"
                                            placeholder="Search for hair, nail, Christmas and more"
                                            onKeyPress={e => onSearchKeyUserUploads(e)}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </Colxx> */}


                                <Colxx xxs="3">
                                    <div className="float-md-right">
                                        <span className="text-muted text-small mr-1">{`${startUserIndex}-${endUserIndex} of ${userTotalItems} `}</span>
                                        <UncontrolledDropdown className="d-inline-block">
                                            <DropdownToggle caret color="outline-dark" size="xs">
                                                {userSelectedPageSize}
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                {userpageSizes.map((size, index) => {
                                                    return (
                                                        <DropdownItem
                                                            key={index}
                                                            onClick={() => changeUserPageSize(size)}
                                                        >
                                                            {size}
                                                        </DropdownItem>
                                                    );
                                                })}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </Colxx>
                            </Row>
                            {!loading && (
                                <Row className='my-3'>
                                        <Colxx xxs="12">
                                            <div className='row'>
                                                {photos && photos.map((img, index) => (
                                                    <div className='col-md-1'>
                                                        <UserUploadSelectedImage
                                                            selected={selectAll ? true : false}
                                                            key={index}
                                                            index={index}
                                                            photo={img}
                                                            ParentUserUploadImage={ParentUserUploadImage}
                                                            chosenImage={chosenImage}
                                                            ParentUserDeleteImage={ParentUserDeleteImage}
                                                            ParentUserEditImage={ParentUserEditImage}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </Colxx>
                                    </Row>
                                )}
                            <Row>
                                <Pagination
                                    currentPage={usercurrentPage}
                                    totalPage={userTotalPages}
                                    onChangePage={i => onChangeUserPage(i)}
                                />
                            </Row>
                            <Row>
                                <Colxx xxs="12">
                                    {togglegallery && (
                                        <div className="float-right">
                                            <Button
                                                color="secondary"
                                                className="add-button"
                                                size="xs"
                                                onClick={AddUserImage}
                                            >
                                                Add to my Chatbot
                                            </Button>
                                        </div>)}
                                </Colxx>
                            </Row>

                        </CardBody>
                    </Card>
                </TabPane>) : null}
            </TabContent>
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, email } = settings;
    return {
        propertyId, email
    };
};

export default injectIntl(connect(mapStateToProps, {})(IconGallery));
